<template>
  <form ref="form" @submit.prevent novalidate>
    <div class="row">
      <div class="telemedicina-container col-12">
        <header class="form-footer" v-if="showFields && !isTelemedicinaSharecareFamiliar">
          <h2 class="form-footer__subtitle">Indique quem terá acesso ao {{ serviceName }}:</h2>

          <div class="row align-center-space">
            <FormControlRadioRefined name="dependents" :options="options" v-model="dependents" />
          </div>
        </header>

        <div class="form-dependents">
          <div v-for="(item, index) in items.additionals" :key="index" class="form-content">
            <button
              type="button"
              v-if="items.additionals.length > 1 && index > 0"
              @click="removeAdditional(index)"
              class="form-dependents__remove"
            >
              <font-awesome-icon :icon="['fas', 'times']" />
            </button>

            <div class="row align-center">
              <h2 v-if="index == 0 && !dependents.value" class="form-footer__subtitle">
                <span v-if="isTelemedicinaSharecareIndividual">
                  Dados de quem vai utilizar a Telemedicina
                </span>
                <span v-else>
                  Dados do titular
                </span>
              </h2>
              <h2 v-else-if="dependents.value" class="form-footer__subtitle">
                Dependente {{ index + 1 }}
              </h2>
              <h2 v-else class="form-footer__subtitle">Dependente {{ index }}</h2>
            </div>

            <div class="row">
              <FormControlInput
                class="col-12"
                icon="user"
                v-model.trim="item.name"
                label="Nome completo"
                :id="`additionalName-${index}`"
                :name="`additionalName-${index}`"
                data-vv-as="Nome completo"
                v-validate="!ignoreAdditionals || !index ? 'required' : ''"
                :valid="
                  !vErrors.has(`additionalName-${index}`) &&
                    fields.additionalName &&
                    fields.additionalName.dirty &&
                    fields.additionalName.valid
                "
                :error="vErrors.collect(`additionalName-${index}`)"
              />
            </div>

            <div class="row">
              <FormControlMask
                class="col-6"
                v-model="item.cpf"
                type="tel"
                label="CPF"
                :id="`additionalCpf-${index}`"
                :name="`additionalCpf-${index}`"
                data-vv-as="CPF"
                v-validate="{
                  required: !ignoreAdditionals || !index ? isRequired : false,
                  regex: /\d{11}/
                }"
                mask="###.###.###-##"
                :valid="
                  !vErrors.has(`additionalCpf-${index}`) &&
                    fields.additionalCpf &&
                    fields.additionalCpf.dirty &&
                    fields.additionalCpf.valid
                "
                :error="vErrors.collect(`additionalCpf-${index}`)"
              />

              <FormControlInput
                class="col-6"
                v-model="item.rg"
                label="RG"
                :id="`additionalRg-${index}`"
                :name="`additionalRg-${index}`"
                data-vv-as="RG"
                v-validate="{ required: !ignoreAdditionals || !index ? isRequired : false }"
                :valid="
                  !vErrors.has(`additionalRg-${index}`) &&
                    fields.additionalRg &&
                    fields.additionalRg.dirty &&
                    fields.additionalRg.valid
                "
                :error="vErrors.collect(`additionalRg-${index}`)"
              />
            </div>

            <div class="row">
              <FormControlMask
                class="col-6"
                v-model="item.birth"
                type="tel"
                label="Data de Nascimento"
                :id="`additionalBirth-${index}`"
                :name="`additionalBirth-${index}`"
                data-vv-as="Data de Nascimento"
                v-validate="{ required: !ignoreAdditionals || !index ? isRequired : false }"
                :masked="true"
                mask="##/##/####"
                :valid="
                  !vErrors.has(`additionalBirth-${index}`) &&
                    fields.additionalBirth &&
                    fields.additionalBirth.dirty &&
                    fields.additionalBirth.valid
                "
                :error="vErrors.collect(`additionalBirth-${index}`)"
              />

              <FormControlSelect
                class="col-6"
                v-model="item.gender"
                :options="gender"
                :value="item.gender"
                label="Sexo"
                :id="`additionalGender-${index}`"
                :name="`additionalGender-${index}`"
                data-vv-as="Sexo"
                v-validate="{ required: !ignoreAdditionals || !index ? isRequired : false }"
                :valid="
                  !vErrors.has(`additionalGender-${index}`) &&
                    fields.additionalGender &&
                    fields.additionalGender.dirty &&
                    fields.additionalGender.valid
                "
                :error="vErrors.collect(`additionalGender-${index}`)"
              />
            </div>

            <div class="row">
              <FormControlInput
                v-model="item.email"
                :id="`additionalEmail-${index}`"
                type="email"
                :name="`additionalEmail-${index}`"
                class="col-6"
                label="E-mail"
                data-vv-as="E-mail"
                icon="envelope"
                v-validate="{
                  required: !ignoreAdditionals || !index ? isRequired : false,
                  email: true
                }"
                :valid="
                  !vErrors.has(`additionalEmail-${index}`) &&
                    fields.additionalEmail &&
                    fields.additionalEmail.dirty &&
                    fields.additionalEmail.valid
                "
                :error="vErrors.collect(`additionalEmail-${index}`)"
              />

              <FormControlMask
                v-model="item.mobile"
                :id="`additionalMobile-${index}`"
                type="tel"
                class="col-6"
                label="Celular"
                data-vv-as="Celular"
                :name="`additionalMobile-${index}`"
                icon="phone-alt"
                mask="(##) #####-####"
                v-validate="{ required: !ignoreAdditionals || !index ? isRequired : false }"
                :valid="
                  !vErrors.has(`additionalMobile-${index}`) &&
                    fields.additionalMobile &&
                    fields.additionalMobile.dirty &&
                    fields.additionalMobile.valid
                "
                :error="vErrors.collect(`additionalMobile-${index}`)"
              />
            </div>
          </div>

          <div v-if="dependents.title.includes('dependente')" class="row align-center">
            <Button
              @click.native="addAdditional()"
              :disabled="items.additionals.length >= 4 && isTelemedicinaSharecareFamiliar"
              type="button"
              class="information-button"
            >
              {{
                isTelemedicinaSharecareFamiliar
                  ? 'Adicionar dependente ' + items.additionals.length
                  : 'Adicionar novo dependente'
              }}
            </Button>
          </div>

          <div
            v-if="items.additionals.length >= 4 && isTelemedicinaSharecareFamiliar"
            class="row align-center"
          >
            <p class="form-subscription-text">Você só pode adicionar 3 dependentes</p>
          </div>

          <div v-if="isTelemedicinaSharecareFamiliar" ref="control" class="control">
            <div class="control-wrap">
              <label>
                <input
                  v-model="ignoreAdditionals"
                  class="control-checkbox"
                  name="cb"
                  type="checkbox"
                  @change="updateValidation"
                />

                Prefiro incluir os dependentes posteriormente no App Vale Saúde Sempre no botão
                Telemedicina.
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-content row">
      <FormPaymentCard class="col-4" :item="subscription" :disabled="true" :selected="true" />
      <div class="col-8">
        <section class="section">
          <div class="row">
            <FormControlInput
              v-model="items.name"
              v-validate="'required|fullname'"
              data-vv-as="Nome Impresso"
              id="name"
              name="name"
              :required="true"
              label="Nome impresso no cartão"
              icon="user"
              class="col-12"
              :error="vErrors.collect('name')"
              :valid="fields.name && fields.name.valid"
            />
          </div>

          <div class="row">
            <FormControlMask
              class="col-12"
              v-model="items.cpf"
              type="tel"
              label="CPF do titular do cartão de crédito"
              id="cpf"
              name="cpf"
              data-vv-as="CPF do titular"
              v-validate="{ required: true, regex: /\d{11}/ }"
              mask="###.###.###-##"
              :valid="!vErrors.has('cpf') && fields.cpf && fields.cpf.dirty && fields.cpf.valid"
              :error="vErrors.collect('cpf')"
            />
          </div>

          <div class="row">
            <FormControlMask
              v-model="items.cardNumber"
              id="cardNumber"
              type="tel"
              :required="true"
              label="Número do cartão de crédito"
              mask="#### #### #### ####"
              icon="credit-card"
              class="col-9"
              name="cardNumber"
              data-vv-as="Número"
              v-validate="'required|numeric|creditcard'"
              :valid="fields.cardNumber && fields.cardNumber.valid"
              :error="vErrors.collect('cardNumber')"
            />

            <FormControlMask
              v-model="items.cvv"
              id="cvv"
              type="tel"
              :required="true"
              label="CVV"
              class="col-3"
              mask="####"
              pattern="([0-9]{3})"
              name="cvv"
              data-vv-as="CVV"
              v-validate="'required|numeric|min:3|max:4'"
              :valid="fields.cvv && fields.cvv.valid"
              :error="vErrors.collect('cvv')"
            />
          </div>

          <div class="row direction-row vertical-center">
            <span class="row-label col-3">Vencimento</span>

            <FormControlMask
              v-model="items.month"
              id="validMonth"
              :required="true"
              label="Mês"
              class="col-4"
              mask="##"
              pattern="([0-9]{2})"
              type="tel"
              :value="items.month"
              name="month"
              data-vv-as="Mês"
              v-validate="'required|min_value:1|max_value:12'"
              :valid="fields.month && fields.month.valid"
              :error="vErrors.collect('month')"
            />

            <FormControlMask
              v-model="items.year"
              id="validYear"
              :required="true"
              label="Ano"
              class="col-4"
              mask="####"
              pattern="([0-9]{3,4})"
              type="tel"
              :value="items.year"
              name="year"
              data-vv-as="Ano"
              v-validate="'required|min:4'"
              :valid="fields.year && fields.year.valid"
              :error="vErrors.collect('year')"
            />
          </div>

          <div class="row align-left">
            <Button type="button" @click.native="showResume = true" :disabled="!formValid">
              Continuar
            </Button>
          </div>
        </section>
      </div>
    </div>

    <Modal class="dd-m-resume" v-show="showResume">
      <div class="dd-m-resume-content">
        <h3>Resumo</h3>
        <h4 v-if="showFields">
          Verifique seus dados e principalmente se incluiu corretamente os dados da pessoa que terá
          acesso ao {{ serviceName }}. Não temos como mudar os dados posteriormente.
          <br />
          O valor da 1ª mensalidade não poderá ser cancelado ou devolvido após você efetuar o
          cadastro.
        </h4>
        <h4 v-else>
          Confirme os dados antes de prosseguir
        </h4>
        <div class="dd-m-resume-content__block">
          <p><span>Nome completo:</span> {{ items.name }}</p>
          <p><span>CPF:</span> {{ items.cpf | cpf }}</p>
          <div v-if="showFields">
            <p>
              <strong>Quem terá acesso ao {{ serviceName }}</strong>
            </p>

            <div v-for="(item, index) in items.additionals" :key="index" class="form-content">
              <p>Dependente {{ index + 1 }}</p>
              <p><span>Nome completo:</span> {{ item.name }}</p>
              <p><span>CPF:</span> {{ item.cpf | cpf }}</p>
              <p><span>RG:</span> {{ item.rg | rg }}</p>
              <p><span>Nascimento:</span> {{ item.birth }}</p>
              <p><span>Sexo:</span> {{ item.gender }}</p>
              <p><span>E-mail:</span> {{ item.email }}</p>
              <p><span>Celular:</span> {{ item.mobile | mobile }}</p>
            </div>

            <div v-if="ignoreAdditionals">
              <p>
                Prefiro incluir os dependentes posteriormente no App Vale Saúde Sempre no botão
                Telemedicina.
              </p>
            </div>
          </div>
        </div>
        <div class="row align-center">
          <Button class="button--option" @click.native="showResume = false" type="button">
            Editar dados
          </Button>

          <Button type="button" @click.native="submit">
            Continuar
          </Button>
        </div>
      </div>
    </Modal>
  </form>
</template>

<script>
import Modal from '@/components/modals/Modal.vue';
import Button from '@/components/buttons/Button.vue';
import FormControlMask from '@/components/forms/control/FormControlMask.vue';
import FormControlInput from '@/components/forms/control/FormControlInput.vue';
import FormControlSelect from '@/components/forms/control/FormControlSelect.vue';
import FormPaymentCard from '@/components/forms/control/FormPaymentCard.vue';
import FormControlRadioRefined from '@/components/forms/control/FormControlRadioRefined.vue';
import genderJson from '@/data/gender.json';

export default {
  name: 'Subscription',
  components: {
    Button,
    FormControlMask,
    FormControlInput,
    FormControlSelect,
    FormPaymentCard,
    FormControlRadioRefined,
    Modal
  },
  props: {
    name: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      dependents: {
        title: 'Eu mesmo',
        value: 0
      },
      options: [
        { title: 'Eu mesmo', value: 0 },
        { title: 'Eu mesmo + dependente(s)', value: 0 },
        { title: 'Apenas dependente(s)', value: 1 }
      ],
      isRequired: null,
      showResume: false,
      showFields: sessionStorage.has_service_additionals === 'true',
      requireSelf: sessionStorage.require_self,
      serviceName: sessionStorage.service_name,
      gender: genderJson,
      items: {
        additionals: [
          {
            name: null,
            cpf: '',
            rg: '',
            birth: '',
            gender: null,
            email: null,
            mobile: null
          }
        ]
      },
      subscription: {
        id: 3,
        method: 'subscription',
        slug: 'calendar-day',
        type: 'Mensalidade',
        description: 'ao mês no cartão de crédito',
        value: sessionStorage.price,
        discountedValue:
          sessionStorage.discounted_price === 'null' ? null : sessionStorage.discounted_price
      },
      previousOption: {
        title: 'Eu mesmo',
        value: 0
      },
      additional: {
        name: null,
        cpf: '',
        rg: '',
        birth: '',
        gender: null,
        email: null,
        mobile: null
      },
      user: JSON.parse(sessionStorage.user),
      isTelemedicinaSharecareFamiliar: false,
      isTelemedicinaSharecareIndividual: false,
      ignoreAdditionals: false
    };
  },
  mounted() {
    const { isTelemedicinaSharecareFamiliar, isTelemedicinaSharecareIndividual } = sessionStorage;

    this.isTelemedicinaSharecareFamiliar = isTelemedicinaSharecareFamiliar === 'true';
    this.isTelemedicinaSharecareIndividual = isTelemedicinaSharecareIndividual === 'true';

    // NOTE: Quando sharecare individual, não devemos preencher os dados do usuário automaticamente
    if (!this.isTelemedicinaSharecareIndividual) {
      this.items.name = this.name;
      this.items.additionals[0] = this.user;
    }

    if (sessionStorage.require_self === 'true') {
      this.options = [
        { title: 'Eu mesmo', value: 0 },
        { title: 'Eu mesmo + dependente(s)', value: 0 }
      ];
    }

    this.$root.$on('subscription-error', value => {
      this.showResume = !value;
    });

    this.$root.$on('form-error', errors => {
      errors.map(error => {
        const field = this.$validator.fields.find({ name: error.key });

        if (field) {
          this.$validator.errors.add({
            id: field.id,
            field: error.key,
            msg: error.value,
            scope: this.$options.scope
          });
        }
        return error;
      });
    });

    this.applyRulesIfIsTelemedicinaFamiliar();
  },
  watch: {
    dependents(e) {
      if (this.previousOption?.value !== e.value) {
        if (e.value === 0) {
          this.items.additionals.unshift(this.user);
        } else {
          this.items.additionals.shift();

          if (this.items.additionals.length === 0) {
            this.items.additionals.push({
              name: null,
              cpf: null,
              rg: null,
              birth: null,
              gender: null,
              email: null,
              mobile: null
            });
          }
        }
      }

      if (!e.title.includes('dependente')) {
        this.items.additionals.splice(1);
      }

      this.isRequired = e.title.includes('dependente');

      this.previousOption = e;
    }
  },
  computed: {
    formValid() {
      return Object.keys(this.fields).every(field => {
        return this.fields[field] && this.fields[field].valid;
      });
    }
  },
  methods: {
    removeAdditional(index) {
      this.items.additionals.splice(index, 1);
    },
    addAdditional() {
      const { isTelemedicinaSharecareFamiliar } = this;
      const { length } = this.items.additionals;

      this.ignoreAdditionals = false;

      // Só pode adicionar 3 dependentes se programa for Telemedicina Sharecare Familiar
      if (length >= 4 && isTelemedicinaSharecareFamiliar) {
        this.$toaster.error('Você só pode adicionar 3 dependentes');
        return;
      }

      const additional = {
        name: null,
        cpf: null,
        rg: null,
        birth: null,
        gender: null,
        email: null,
        mobile: null
      };
      this.items.additionals.push(additional);
    },
    submit() {
      this.$emit('submit', this.items);
    },

    /**
     * @description
     * Caso o programa atual seja o Telemedicina Sharecare Familiar
     * precisamos setar a opção Eu mesmo + Dependentes
     */
    applyRulesIfIsTelemedicinaFamiliar() {
      const { isTelemedicinaSharecareFamiliar } = this;

      if (isTelemedicinaSharecareFamiliar) {
        this.dependents.title = this.options[1].title;
      }
    },
    async updateValidation() {
      this.$nextTick(async () => {
        if (this.ignoreAdditionals) {
          this.items.additionals.splice(1, this.items.additionals.length);
        }

        await this.$validator.validateAll();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.form-subscription-text {
  padding: 0;
  margin: 0;
  font-size: 14px;
}
</style>
